$(document).ready(function(){
  $(document).on('change','.product-varient-select-on select',function(){
    var varient_idd = $(this).val();
    $(this).parents('.grid__item').find('.product--id').val(varient_idd);
  });

  $(document).on('click','.grid-option-select-on .variant-option-wp ',function(){
    $(this).addClass('selected').siblings().removeClass('selected');
    var varient_idd2 = $(this).attr('variant-id');
    // $(this).parents('.grid__item').find('.product--id').val(varient_idd2);
    $(this).parents('.grid__item-image-wrapper').find('.product--id').val(varient_idd2)
  })
})


$('#track-order').submit(function(e){
  e.preventDefault();
  $('.response',this).html('')
  var awb = $('#awb',this).val();
  if(!awb){
    $('.response',this).html('<div class="error"><br/>Please Enter a Valid AWB/Order Number</div>')
    return;
  }
  window.open('https://ecomexpress.in/track-shipment/'+awb)
})
//only characters allowed
        $('.input-text').keyup(function(){
            this.value = this.value.replace(/[^A-Z a-z]/g,'').trimStart();
        });

        //only numbers allowed
        $('.input-number').keyup(function(){
            this.value = this.value.replace(/[^0-9]/g,'').trimStart();
        });
        
        //email validation
        $('.input-email').keyup(function(){
            var newValue = this.value.replace(/\.\./g, ".");
            //remove .@
            newValue = newValue.replace(/\.@/g,"@");
            //remove extra chars
            newValue = newValue.replace(/[^A-Z a-z0-9.@_-]/g,'');
            //multiple @
            newValue = newValue.replace(/\@@/g,"@");
  
            this.value = newValue.trimStart();
        });
        $('.input-email').change(function(){
            newValue = this.value;
            if( newValue[newValue.length-1] == '.'){
                newValue = newValue.substring(0,newValue.length-1)
            }
          
          this.value = newValue.trimStart()
        })